import PoolDevice from "./base";
import { PoolDeviceInterface } from "../Interfaces";
import { DisplayProcessingLogics, StatesToDisplayItem, PoolDevicePropertyToDisplay, DisplayWidths } from "../Types";
import Locale from "../../utils/Locale";
import { DeviceTypes } from "../../config/documents/HardwareConfig";
import { ValueAndUnit } from "../../types";


export default class PoolDeviceWaterLevelSensor extends PoolDevice implements PoolDeviceInterface {
    static minAutoFilterVersion = 9;
    static DeviceType = DeviceTypes.WATERLEVELSENSOR;
    static Icon = "water-percent";
    static PickerTitle = Locale.gettext("Water Level Sensor");

    formatDeviceStatusCustom(DisplayProcessingLogic: DisplayProcessingLogics, value: any): ValueAndUnit {
        switch(DisplayProcessingLogic) {
        case DisplayProcessingLogics.WATER_SENSOR:
            return { value: value ? Locale.gettext("In Water") : Locale.gettext("Out of Water") };
        default: return super.formatDeviceStatusCustom(DisplayProcessingLogic, value);
        }
    }

    getInformationFields(): StatesToDisplayItem[] {
        let order = 0;
        const fields = [];
    
        {
            const DisplayName = Locale.gettext("Sensor State");
            fields.push({
                Name: PoolsideDaemonDeviceStateNames.SensorState,
                DisplayName, DisplayNameShort: DisplayName,
                DisplayOrder: ++order,
                DisplayProcessingLogic: DisplayProcessingLogics.ONOFF,
                DisplayProcessingLogicUnitAsDisplayName: false,
                DisplayWidth: DisplayWidths.WIDE
            });
        }
    
        return fields;
    }
}

export enum PoolsideDaemonDeviceStateNames {
    SensorState = "SensorState"
}


    
